<template lang="pug">
  header(:class="stickyHeaderClass")
    .sticky-mobile-bar
      button.hamburger.hamburger--3dy(
        type="button"
        :class="{ 'is-active': sidebar }"
        @click="toggleSidebar"
      )
        span.hamburger-box
          span.hamburger-inner
      ShoppingCart
    
    .sticky-social
      ul
        li
          router-link(to="/kontakt")  
            span 
              font-awesome-icon(icon="phone-alt")
        li
          a(href="https://www.facebook.com/campusundcollege/" target="_blank")
            span 
              font-awesome-icon(:icon="{prefix: 'fab', iconName: 'facebook-f'}")

    .header-menu-wrap
      .container.mx-auto.flex
        //div.left.social
          a(href="https://www.facebook.com/campusundcollege/" target="_blank")
            font-awesome-icon(:icon="{prefix: 'fab', iconName: 'facebook-f'}")
        div.right
          Menu#header-menu(k="header-menu" :max-depth="1")
          a.tel(href="tel:00496028120870") Telefon: +49 (0)6028 1208-0
    .container.mx-auto.flex.header-bottom
      .logo
          component(:is="logoWrap" v-bind="logoWrapProps")
            img(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
            img(v-else src="@/assets/logo.png")
      Menu#main-menu(k="main-menu" :max-depth="2")
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { trim } from '@/helpers';

import Menu from '@/components/Menu.vue';
import ShoppingCart from '@/extensions/shop/components/ShoppingCart.vue';

export default {
    name: 'Header',
    data: () => ({
        lastScroll: 0,
        stickyHeaderClass: ''
    }),
    components: {
        Menu,
        ShoppingCart
    },
    computed: {
        logoWrap() {
            let tag = 'div';
            if (this.$route.path !== '/') {
                tag = 'a';
            }
            return tag;
        },
        logoWrapProps() {
            let props = {};
            if (this.$route.path !== '/') {
                props = { href: '/' };
            }
            return props;
        },
        image() {
            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            const fit = 'fit&h=160';

            let width = this.logo.width;
            let height = this.logo.height;

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height
            };
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            sidebar: 'sidebar'
        })
    },
    methods: {
        openSearch() {
            console.log('open search bar');
        },
        toggleSidebar() {
            this.updateSidebarVisibility(!this.sidebar);
        },

        updateStickyHeader() {
            const currentScroll = window.pageYOffset;

            const scrollUp = 'scroll-up';
            const scrollDown = 'scroll-down';

            if (currentScroll > this.lastScroll && this.stickyHeaderClass !== scrollDown) {
                this.stickyHeaderClass = scrollDown;
            } else if (currentScroll < this.lastScroll && this.stickyHeaderClass !== scrollUp) {
                this.stickyHeaderClass = scrollUp;
            }

            this.lastScroll = currentScroll;
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.updateStickyHeader);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.updateStickyHeader);
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

header

  &.scroll-down
    //position: sticky
    //top: 0
    //z-index: 9999
    //transition: transform .15s linear
    .header-bottom
      //min-height: 100px


  @apply flex items-center justify-end flex-col bg-white
  box-shadow: 0 0 3px 0 rgba(0,0,0,0.22)
  .header-bottom
    @apply flex items-center justify-end

    @screen lg
      @apply justify-center
      min-height: 118px
    .logo
      @apply float-right
      padding: 20px 0
      @screen lg
        @apply float-none
      img
        height: 50px
        @screen lg
          height: 80px

  .sticky-mobile-bar
    @apply absolute
    top: 18px
    left: 0
    backdrop-filter: blur(20px)
    transition: transform .15s linear
    z-index: 10
    color: $cc-blue
    @screen md
      left: 98px
    @screen lg
      @apply hidden
    &.scroll-down
      transform: translateY(-54px)
    .hamburger
      height: 53px
      padding: 15px
      .hamburger-inner
        background-color: $cc-blue
        &:before, &:after
          background-color: $cc-blue
    .shopping-cart
      padding: 0 1rem

  .sticky-social
    @apply hidden
    @screen lg
      @apply block fixed
      top: 30%
      z-index: 1000
      right: -23px
      li
        background-color: $cc-green
        margin-bottom: 1px
        transition: transform 100ms
        &:hover
          transform: translate(-15px, 0)
        span
          @apply inline-block text-center text-white
          padding-right: 20px
          line-height: 52px
          width: 70px
          font-size: 14px


  .header-menu-wrap
    @apply w-full hidden
    @screen lg
      @apply block

    font-family: $font-alternative
    height: 34px
    line-height: 34px
    background-color: $cc-blue
    .left.social
      border-left: 1px solid rgba(0,0,0,0.1)
      border-right: 1px solid rgba(0,0,0,0.1)
      padding: 0 10px
      svg
        @apply transition duration-500 ease-in-out text-white
        height: 14px
        &:hover
          color: $cc-green
    .right
      @apply font-bold transition-colors text-white uppercase flex
      font-size: 11px
      margin-left: auto
      a.tel
        padding: 0 10px
        border-left: 1px solid rgba(0,0,0,0.1)
        border-right: 1px solid rgba(0,0,0,0.1)

    #header-menu
      @apply hidden
      @screen lg
        @apply block
      ::v-deep ul
        & > li
          @apply inline-block border-0
          &.active .tree-item a
            color: $cc-green
          .tree-item > a
            @apply font-bold transition duration-500 ease-in-out text-white uppercase
            padding: 10px
            border-left: 1px solid rgba(0,0,0,0.1)
            &:hover
              color: $cc-green

  #main-menu
    @apply hidden
    @screen lg
      display: block
      margin-left: auto
    &::v-deep
      ul
        &.tree-menu
          & > li

            transition: background-color .3s ease
            position: relative
            &.active > .tree-item > a:after,
            &.active.visible.hover > .tree-item > a:after
              transform: scaleX(1)

            &.visible.hover > .tree-item > a
              color: $cc-blue
              &:after
                transform: scaleX(1)

            &.visible.hover.has-children
              > .tree-item a
                color: $cc-blue

            &:last-of-type > .tree-item a
              margin-right: 0

            &:not(.full-width)
              position: relative
            & > .tree-item a
              @apply font-semibold
              font-family: $font
              font-size: 22px
              padding-bottom: 44px
              padding-top: 24px
              margin: 0 10px
              text-decoration: none
              color: $cc-blue
              transition: color .15s ease, border-color .3s ease
              &:after
                transition: transform .3s ease-out,border-color .3s ease-out
                position: absolute
                display: block
                bottom: -6px
                left: 0
                width: calc(100% - 20px)
                transform: scaleX(0)
                border-top: 2px solid $cc-green
                border-top-color: $cc-green
                content: ''
                margin-left: 10px
              & > .active
                color: #fff
            li
              width: 100%
              & > .tree-item a
                font-family: $font-alternative
                color: #fff
                background: $cc-green
                display: block
                max-width: 300px
                letter-spacing: 0
                font-size: 16px
                line-height: 16px
                font-weight: 500
                padding: 14px
                margin: 0
                &:hover
                  background-color: $cc-blue
                  color: #fff !important
                &:after
                  transform: scaleX(0) !important
              &.hover
                & > .tree-item a
                  color: #fff
      & > ul
        &.tree-menu
          & > li
            display: inline-block
            & > ul
              &.tree-menu
                z-index: 100
                position: absolute
                top: 75px
                left: 0
                display: inline-block
                min-width: 200px
                box-shadow: 0 2px 2px rgba(0,0,0,0.2)
                &.full-width
                  width: 100%
                  columns: 3
                  column-gap: 0
                  display: inline-block
                  @screen xl
                    columns: 4
          ul ul
            min-width: 200px
            margin-bottom: 9px
            position: absolute
            left: 100%
            top: 0
            box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)

      .show-enter-active, .show-leave-active
        transition: opacity 0.3s ease, transform 0.3s ease
        transform-origin: left center
      .show-enter, .show-leave-to
        opacity: 0
        transform: translateY(6px)

  //- #header-menu,
  //- #main-menu
  //-   @screen lg
  //-     @screen widescreen
  //-       padding-right: 10rem
</style>
